import { jsx as s, jsxs as a } from "react/jsx-runtime";
import n from "../link-wrapper/link-wrapper.js";
import e from "./shortcut.module.less.js";
const m = ({ title: i, icon: r, url: t }) => {
  const l = r && typeof r == "string";
  return /* @__PURE__ */ s(n, { url: t, className: e.linkWrapper, children: /* @__PURE__ */ a("div", { className: [e.wrapper, l ? e.withPresetIcon : ""].join(" "), children: [
    r && /* @__PURE__ */ s("div", { className: e.icon, children: /* @__PURE__ */ s("span", { className: r }) }),
    /* @__PURE__ */ a("div", { className: e.titleIconWrapper, children: [
      /* @__PURE__ */ s("div", { className: [e.title, "body-base mb-0"].join(" "), children: i }),
      !r && /* @__PURE__ */ s("span", { className: [r, "ui-icon-arrow-right"].join(" ") })
    ] })
  ] }) });
};
export {
  m as Shortcut
};
